/**
 * The one dynamic `import()` in the shell, isolated in its own module.
 *
 * A custom module's entry point is an ESM file served by the backend from an extracted
 * bundle, at a URL only known at runtime. That makes this import different from every
 * other import in the app in two ways, and both are why it lives alone:
 *
 *   * **The bundler must not touch it.** `webpackIgnore` tells webpack to emit the
 *     `import()` as-is instead of trying to resolve a module that is not in this app's
 *     build graph — without it the build fails on a specifier it cannot find.
 *
 *   * **jsdom cannot execute it.** There is no module loader for an HTTP URL in the test
 *     environment, so `ModuleHost`'s lifecycle would be untestable if the import were
 *     inline. A one-function module is a real boundary a test can `jest.mock`, which is
 *     better than a test-only global on `window` — the seam is visible in production code
 *     and cannot silently change shape.
 */

/**
 * Import a custom module's ESM entry and return its exports.
 *
 * @param {string} url - absolute URL of the module's entry, e.g. /modules/<slug>/entry.js
 * @returns {Promise<{mount: Function, unmount?: Function}>}
 */
export function loadModuleEntry(url) {
    return import(/* webpackIgnore: true */ url);
}

export default loadModuleEntry;
